import { render } from "./ButtonsPrevNext.vue?vue&type=template&id=19503968"
import script from "./ButtonsPrevNext.vue?vue&type=script&lang=js"
export * from "./ButtonsPrevNext.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ButtonsPrevNext.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19503968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19503968', __exports__)) {
    console.log('reload')
    api.reload('19503968', __exports__)
  }
  
  module.hot.accept("./ButtonsPrevNext.vue?vue&type=template&id=19503968", () => {
    console.log('re-render')
    api.rerender('19503968', render)
  })

}


export default __exports__